import PropTypes from 'prop-types';
import cn from 'classnames';

import ImageComparisonSliderTitle from './ImageComparisonSliderTitle.jsx';
import ImageComparisonSliderImages from './ImageComparisonSliderImages.jsx';
import ImageComparisonSliderCaption from './ImageComparisonSliderCaption.jsx';

export default function LdsImageComparisonSlider({
  caption,
  controlBtnAriaLabel = 'Move left or right to compare images',
  hiddenControlBtnText = 'Move by clicking and dragging or using your arrow keys to see the difference between the two images',
  id,
  image1,
  image2,
  className,
  ...rest
}) {
  return (
    <div
      className={cn(
        'lds-image-comparison-slider',
        className
      )}
      {...rest}
    >
      <ImageComparisonSliderTitle
        id={id}
        imgTitle1={image1?.title}
        imgTitle2={image2?.title}
      />
      <ImageComparisonSliderImages
        controlBtnAriaLabel={controlBtnAriaLabel}
        hiddenControlBtnText={hiddenControlBtnText}
        id={id}
        image1={image1}
        image2={image2}
      />
      <ImageComparisonSliderCaption
        id={id}
        caption={caption}
      />
    </div>
  );
}

LdsImageComparisonSlider.propTypes = {
  caption: PropTypes.string,
  controlBtnAriaLabel: PropTypes.string,
  hiddenControlBtnText: PropTypes.string,
  id: PropTypes.string.isRequired,
  image1: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string,
    title: PropTypes.string,
  }),
  image2: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string,
    title: PropTypes.string,
  }),
};
